import { message } from "antd";
import { queryInboxDetail, queryOutboxDetail, receipt } from "../../../../services/notice/detail";

const initState = {
  detailKey: Date.now(),
  detail: null,
  id: 0 // list 中获取到的id
};
export default {
  namespace: "salaryDetail",

  state: initState,

  effects: {
    // 通知发件箱/收件箱详情
    *fetchDetail({ payload }, { call, put }) {
      try {
        const { id, isOutbox } = payload;
        const response = yield call(isOutbox ? queryOutboxDetail : queryInboxDetail, { id });

        const { picList, receiptVO = {} } = response;

        const newAnnexList = (picList || []).filter(pic => pic.type !== 2).map(({ size, url }) => {
          const arr = url.split("/");
          const name = `${arr[arr.length - 1]}.png`;

          return {
            format: "png",
            name,
            size,
            type: null,
            url
          };
        });

        // 处理手机端上传图片
        response.annexList = newAnnexList;

        // 录音附件
        if (!response.duration && !response.tapeUrl) {
          (picList || []).filter(item => item.type === 2).map(item => {
            response.duration = item.duration
            response.tapeUrl = item.url;
            return !0;
          })
        }

        yield put({
          type: "save",
          payload: {
            detail: {
              ...response,
              ...receiptVO,
            }
          }
        });

        return Promise.resolve();

      } catch (error) {
        return Promise.reject();
      }
    },
    *fetchReceipt({ payload }, { call, put, select }) {
      try {
        const { question } = payload;
        if (
          question.match(/\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g) !=
          null
        ) {
          message.warning("不支持发布表情等符号");
          return Promise.reject();
        }
        yield call(receipt, payload);

        message.success("回执成功");

        return Promise.resolve();

      } catch (error) {
        return Promise.reject();

      }
    }
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    reset() {
      return { ...initState };
    }
  }
};
